import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // Fonction pour rediriger selon le rôle de l'utilisateur
  const redirectUserByRole = (userData) => {
    if (userData.role === "superadmin" || userData.role === "admin" || 
        userData.role === "charge-affaire" || userData.role === "projectmanager") {
      console.log("Redirection vers admin dashboard pour rôle:", userData.role);
      navigate("/admin");
    } else if (userData.role === "client") {
      // CORRIGÉ: Toujours rediriger vers /client pour les clients
      // ClientDashboard.js se chargera de la logique multi-projets
      console.log("Redirection vers client dashboard");
      navigate("/client");
    } else {
      console.warn("Rôle non reconnu:", userData.role, "- redirection vers dashboard par défaut");
      navigate("/dashboard");
    }
  };

  // Redirection automatique si l'utilisateur est déjà connecté
  useEffect(() => {
    if (user && user.role && user.role !== 'unknown') {
      console.log("Utilisateur déjà connecté, redirection automatique:", user);
      redirectUserByRole(user);
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    
    try {
      await login(email, password);
      // Note: Ne pas rediriger ici car useEffect se chargera de la redirection
      // quand l'utilisateur sera mis à jour dans le contexte
    } catch (err) {
      console.error("Erreur de connexion:", err);
      setError("Erreur lors de la connexion");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-12">
      <h2 className="text-2xl font-bold mb-4">Connexion</h2>
      {error && <div className="mb-4 text-red-600">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block mb-1 font-semibold">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border rounded px-3 py-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block mb-1 font-semibold">Mot de passe</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border rounded px-3 py-2"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
        >
          Se connecter
        </button>
      </form>
    </div>
  );
};

export default Login;